import { Menu, Home, ImportContacts, HeadsetMic, DirectionsRun, BarChart, } from '@mui/icons-material';
import { Box, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography, } from '@mui/material';
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import setActiveLink from '../../utils/setActiveLink';
function TemporalyDrawer() {
    var _a = useState(false), state = _a[0], setState = _a[1];
    var toggleDrawer = function (open) {
        return function (event) {
            if (event.type === 'keydown' &&
                (event.key === 'Tab' ||
                    event.key === 'Shift')) {
                return;
            }
            setState(open);
        };
    };
    var Icons = [
        React.createElement(Home, { key: 1 }),
        React.createElement(ImportContacts, { key: 2 }),
        React.createElement(HeadsetMic, { key: 3 }),
        React.createElement(DirectionsRun, { key: 4 }),
        React.createElement(BarChart, { key: 5 }),
    ];
    var list = function () { return (React.createElement(Box, { sx: { width: 250, mt: 12 }, role: "presentation", onClick: toggleDrawer(false), onKeyDown: toggleDrawer(false) },
        React.createElement(Typography, { variant: "h4" }, "\u0413\u043B\u0430\u0432\u043D\u043E\u0435 \u043C\u0435\u043D\u044E"),
        React.createElement(List, null, ['Главная', 'Учебник', 'Аудиовызов', 'Спринт', 'Статистика'].map(function (text, index) { return (React.createElement(ListItem, { key: text, disablePadding: true },
            React.createElement(NavLink, { className: setActiveLink, to: index ? String(index) : '/' },
                React.createElement(ListItemButton, null,
                    React.createElement(ListItemIcon, null, Icons[index]),
                    React.createElement(ListItemText, { primary: text }))))); })))); };
    return (React.createElement("div", null,
        React.createElement(Menu, { onClick: toggleDrawer(true), cursor: "pointer" }),
        React.createElement(Drawer, { open: state, onClose: toggleDrawer(false) }, list())));
}
export default TemporalyDrawer;
